import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Navbar as BSNavbar, Dropdown } from "react-bootstrap";
import { FiBell, FiLogOut } from "react-icons/fi";
import logo from "./../assets/images/logo2.png";
import logo2 from "./../assets/images/logo3.png";
import style from "./../styles/Navbar.module.css";
import { authActions } from "../Features/authSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import NotificationDropdown from "./NotificationDropdown/NotificationDropdown";

const Topbar = ({ toggle, isSandwichOpen }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [activeBell, setActiveBell] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userType = user?.user_type;
  const permissions = user?.permissionObject;

  // const userName = user.user_full_name.charAt(0);
  const userName1 = user.user_full_name.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), "");
  const notification = useSelector((state) => state.notification);

  const logout = () => {
    localStorage.removeItem("refreshToken");
    dispatch(authActions.logout());
    navigate("/login");
  };

  useEffect(() => {
    if (pathname === "/notifications") {
      setActiveBell(true);
    } else {
      setActiveBell(false);
    }
  }, [pathname]);
  const handleNotificationDropdown = () => {
    if (window.innerWidth < 576) {
      navigate("/notifications");
      setNotificationDropdown(false);
    } else {
      setActiveBell((prev) => !prev);
      setNotificationDropdown((prev) => !prev);
    }
  };

  return (
    <>
      <BSNavbar className="shadowMain topbar position-fixed w-100" bg="white" style={{ zIndex: "3" }}>
        <div className="px-3 d-flex justify-content-between align-items-center w-100 topbar-inner">
          <div className={`d-flex justify-content-center align-items-center ${style.navItem}`}>
            <div className="d-flex align-items-center gap-2">
              <img src={logo2} className="topbar-logo" alt="logo" style={{ height: "26px" }} />
              {!isSandwichOpen && <img src={logo} className="topbar-logo d-none d-md-inline" alt="logo" style={{ height: "22px" }} />}
            </div>
            <div className="topbar-toggle ms-1">
              <FontAwesomeIcon role="button" icon={faBars} size="sm" onClick={() => toggle()} />
            </div>
          </div>
          <div className={`d-flex align-items-center justify-content-end gap-2`}>
            {userType === "super-admin" || Number(permissions?.Shopkeeper) === 1 || Number(permissions?.Subscription) === 1 ? (
              <div style={{ position: "relative" }} className="me-1">
                <div className="topbar-bell notificationButton" onClick={pathname === "/notifications" ? null : handleNotificationDropdown}>
                  <FiBell size={16} color={activeBell ? "#8834ff" : "#697386"} />
                  <div className={`${style.notificationBadge} notificationButton`}>
                    <span className={`${style.notificationCount} notificationButton`}>{+notification.notificationsCount > 99 ? "99+" : notification.notificationsCount}</span>
                  </div>
                </div>

                {notificationDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "36px",
                      right: 0,
                      width: "100%",
                    }}
                  >
                    <NotificationDropdown
                      show={notificationDropdown}
                      handleClose={() => {
                        setActiveBell(false);
                        setNotificationDropdown(false);
                      }}
                    />
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}

            <div>
              <Dropdown className={`d-flex d-lg-inline d-md-inline justify-content-end ${style.toggle}`}>
                <Dropdown.Toggle variant="light" className={`border-0 p-0 text-secondary`} id="dropdown-basic" style={{ background: "transparent" }}>
                  <div className={`topbar-avatar`}>{userName1}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="topbar-dropdown-menu" style={{ right: 0, left: "auto", top: "38px" }} align="end">
                  <Dropdown.Item className="topbar-dropdown-item" href="" eventKey="true">
                    <span className={`${style.signOut} d-flex justify-content-start gap-2`} onClick={logout}>
                      <FiLogOut size={16} /> Sign Out
                    </span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </BSNavbar>
    </>
  );
};

export default Topbar;
